import { render } from "./AddNewMessage.vue?vue&type=template&id=09c96834&scoped=true"
import script from "./AddNewMessage.vue?vue&type=script&lang=js"
export * from "./AddNewMessage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c96834"]])

export default __exports__